import { AbstractControl, FormGroupDirective } from '@angular/forms';
import { DestroyRef, Directive, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { distinctUntilChanged, EMPTY, merge } from 'rxjs';

import { ChrHelperDirective } from '@ciphr-design-system/angular';

import { ValidationErrorMessageService } from './validation-error-message.service';

@Directive({
  selector: '[ciphrHelperValidationError]',
  standalone: true,
})
export class HelperValidationErrorDirective implements OnInit {
  private destroyRef = inject(DestroyRef);
  private formGroup = inject(FormGroupDirective, { host: true, optional: true });
  private helperDirective = inject(ChrHelperDirective, { optional: true });
  private validationErrorMessageService = inject(ValidationErrorMessageService);

  control = input.required<AbstractControl>({ alias: 'ciphrHelperValidationError' });

  ngOnInit(): void {
    const helper = this.helperDirective;
    const controlName = this.getControlName();

    if (helper) {
      helper.error = true;

      merge(this.formGroup?.ngSubmit.asObservable() ?? EMPTY, this.control().statusChanges?.pipe(distinctUntilChanged()) ?? EMPTY)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          const errors = this.control().errors;

          if (errors) {
            helper.content = this.validationErrorMessageService.translateValidationError(errors, controlName);
          } else {
            helper.content = '';
          }
        });
    } else {
      console.warn('ciphrHelperValidationError can only be used with chr-helper component');
    }
  }

  private getControlName() {
    const controlName = Object.keys(this.control().parent?.controls || {}).find(
      (name) => this.control().parent?.get(name) === this.control(),
    );

    return controlName ? controlName : '';
  }
}
